"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _bowser = _interopRequireDefault(require("bowser"));

var _nrdAsyncMetric = _interopRequireDefault(require("../NRD/nrd-async-metric"));

var _dataGathering = require("./util/dataGathering");

var _uuid = _interopRequireDefault(require("../uuid"));

var _globalLogHandler = _interopRequireDefault(require("./globalLogHandler"));

var _NRDService = _interopRequireDefault(require("./Service/NRDService"));

var _merge = _interopRequireDefault(require("./util/merge"));

var _browser = require("./util/browser");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var NRD = /*#__PURE__*/function () {
  function NRD(name, additionalLogData, batchSize, batchInterval) {
    _classCallCheck(this, NRD);

    this.name = name;
    this.batchSize = batchSize;
    this.batchInterval = batchInterval;
    this.fetch = _NRDService["default"];
    this.bowser = this.initiateBowser();
    this.globalLogData = generateAdditionalLogData(name, additionalLogData, this.bowser);
    (0, _globalLogHandler["default"])(this);
  }

  _createClass(NRD, [{
    key: "asyncMetric",
    value: function asyncMetric(eventId) {
      var logToSignalFX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new _nrdAsyncMetric["default"](this, eventId, logToSignalFX);
    }
  }, {
    key: "debug",
    value: function debug(log) {
      this.buildLog('DEBUG', log, true);
    }
  }, {
    key: "info",
    value: function info(log) {
      this.buildLog('INFO', log, true);
    }
  }, {
    key: "warn",
    value: function warn(log) {
      this.buildLog('WARN', log, true);
    }
  }, {
    key: "error",
    value: function error(log) {
      this.buildLog('ERROR', log, false);
    }
  }, {
    key: "metric",
    value: function metric(log) {
      log = _objectSpread({
        appContext: {
          success: true
        }
      }, log);
      this.buildLog('METRIC', log);
    }
  }, {
    key: "buildLog",
    value: function buildLog(logLevel, log, successState) {
      if (!log.hasOwnProperty('appContext')) {
        log.appContext = {};
      }

      if (logLevel) {
        log.appContext.metric = logLevel;
      }

      if (successState != undefined) {
        log.appContext.success = successState;
      }

      log = _objectSpread({
        startMillis: Date.now(),
        endMillis: Date.now()
      }, (0, _merge["default"])({}, this.globalLogData, log));
      var logHandler = (0, _globalLogHandler["default"])(this);
      logHandler.add(log);
    }
  }, {
    key: "dispatchLogs",
    value: function dispatchLogs() {
      var logHandler = (0, _globalLogHandler["default"])(this);
      logHandler.requestNRD();
    }
  }, {
    key: "initiateBowser",
    value: function initiateBowser() {
      if (typeof window === 'undefined') {
        return {};
      }

      try {
        var userAgent = window.navigator && window.navigator.userAgent ? window.navigator.userAgent : '';
        return _bowser["default"].getParser(userAgent);
      } catch (error) {
        return {};
      }
    }
  }]);

  return NRD;
}();

function generateAdditionalLogData(name, additionalLogData, bowser) {
  var appContextData = {};

  try {
    appContextData = {
      os: bowser.getOSName(),
      osVersion: bowser.getOSVersion(),
      browser: bowser.getBrowserName(),
      browserVersion: bowser.getBrowserVersion(),
      device: bowser.getPlatformType(),
      engineName: bowser.getEngineName()
    };
    var urlPath = (0, _browser.getURLPath)();

    if (urlPath) {
      appContextData['urlPath'] = urlPath;
    }
  } catch (error) {
    appContextData = {};
  }

  var generatedLog = {
    appName: name,
    serviceLogVersion: 'v2',
    brandId: 'SFLY',
    visitorId: (0, _dataGathering.getVisitorId)(),
    sessionId: (0, _uuid["default"])(),
    appContext: _objectSpread({}, appContextData)
  };
  return (0, _merge["default"])({}, generatedLog, additionalLogData || {});
}

function _default(name, additionalLogData, batchSize, batchInterval) {
  return new NRD(name, additionalLogData, batchSize, batchInterval);
}